// @ts-nocheck
import React, { useState, useEffect } from 'react'
import styles from '../css/AddExercise.module.css'
import targetingDefaultPerTargetLimits from '../../../lookup/admin/targeting/targetingDefaultPerTargetLimits.json'
import { Tooltip } from 'antd';

function AddExercise(props) {

    const [name, setName] = useState(props.exercise.name || "")
    const [startDate, setStartDate] = useState(props.exercise.startDate || "")
    const [endDate, setEndDate] = useState(props.exercise.endDate || "")
    const [maxChangesPerTerritory, setMaxChangesPerTerritory] = useState(0)
    const [minChangesPerTerritory, setMinChangesPerTerritory] = useState(0)
    const [maxCallsPerTerritory, setMaxCallsPerTerritory] = useState(0)
    const [minCallsPerTerritory, setMinCallsPerTerritory] = useState(0)
    const [maxUpgradesPerTerritory, setMaxUpgradesPerTerritory] = useState(0)
    const [maxDowngradesPerTerritory, setMaxDowngradesPerTerritory] = useState(0)
    const [limitType, setLimitType] = useState(
        props.team ? (targetingDefaultPerTargetLimits.team[props.team]?.defaultLimitType ?? 'percent') : 'percent'
    )

    const [wiggle, setWiggle] = useState(false)
    const [valid, setValid] = useState(true)

    useEffect(() => {
        //max territory
        if (props.team && targetingDefaultPerTargetLimits.team[props.team].defaultMaxChangesPerTerritory > 0) {
            setMaxChangesPerTerritory(targetingDefaultPerTargetLimits.team[props.team].defaultMaxChangesPerTerritory)
        }
        else {
            setMaxChangesPerTerritory(0)
        }
        //min territory
        if (props.team && targetingDefaultPerTargetLimits.team[props.team].defaultMinChangesPerTerritory > 0) {
            setMinChangesPerTerritory(targetingDefaultPerTargetLimits.team[props.team].defaultMinChangesPerTerritory)
        }
        else {
            setMinChangesPerTerritory(0)
        }
        if (props.team && targetingDefaultPerTargetLimits.team[props.team].defaultMaxUpgradesPerTerritory > 0) {
            setMaxUpgradesPerTerritory(targetingDefaultPerTargetLimits.team[props.team].defaultMaxUpgradesPerTerritory)
        } else { setMaxUpgradesPerTerritory(0) }
        if (props.team && targetingDefaultPerTargetLimits.team[props.team].defaultMaxDowngradesPerTerritory > 0) {
            setMaxDowngradesPerTerritory(targetingDefaultPerTargetLimits.team[props.team].defaultMaxDowngradesPerTerritory)
        } else { setMaxDowngradesPerTerritory(0) }
        if (props.team) {
            setLimitType(targetingDefaultPerTargetLimits.team[props.team]?.defaultLimitType ?? 'percent')
        }
    }, [props.team])

    return (
        <div className={styles.editScreen}>
            <div className={styles.title}>
                <div></div>
                <div className={styles.titleText}>Add Exercise</div>
                <div className={styles.close} onClick={() => {
                    props.close()
                }}><span aria-hidden="true">×</span></div>
            </div>
            <form>
                <div className={styles.body}>
                    <div className={styles.required}>REQUIRED FIELD *</div>
                    <div className={styles.content}>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>NAME <div className={styles.required}>*</div></div>
                            <input type="text" className={valid || name !== "" ? styles.default : styles.error} value={name} onChange={(event) => {
                                setName(event.target.value)
                            }} autoFocus />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>TEAM <div className={styles.required}>*</div></div>
                            <select type="text" className={valid || props.team !== "" ? styles.default : styles.error} value={props.team} onChange={(event) => {
                                props.setTeam(event.target.value)
                            }}>
                                <option value=""></option>
                                <option value="13">13</option>
                                <option value="15">15</option>
                                <option value="14">14</option>
                                <option value="21">21</option>
                                <option value="31">31</option>
                                <option value="33">33</option>
                                <option value="61">61</option>
                            </select>
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>START DATE <div className={styles.required}>*</div></div>
                            <input type="date" max={endDate || undefined} className={valid || startDate !== "" ? styles.default : styles.error} value={startDate} onChange={(event) => {
                                setStartDate(event.target.value)
                            }} />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>END DATE <div className={styles.required}>*</div></div>
                            <input type="date" min={startDate || undefined} className={valid || endDate !== "" ? styles.default : styles.error} value={endDate} onChange={(event) => {
                                setEndDate(event.target.value)
                            }} />
                        </div>
                        <div className={styles.set}>
                            <Tooltip title="Leave blank to maintain legacy functionality.  This will help drive configurabiliy over time.">
                                <div className={styles.inputTitle}>EXERCISE TYPE </div>
                            </Tooltip>
                            <select type="text" className={valid || props.exerciseType !== "" ? styles.default : styles.error} value={props.exerciseType} onChange={(event) => {
                                props.setExerciseType(event.target.value)
                            }}>
                                <option value=""></option>
                                <option value="No Access">No Access</option>
                                <option value="Re-Targeting Exercise">Re-Targeting Exercise</option>
                            </select>
                        </div>
                        <div className={styles.set}>
                            <div className={styles.gridPlaceholder}></div>
                        </div>
                        <div className={styles.set} style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div className={styles.inputTitle}>LIMIT MODE</div>
                            <div style={{ display: 'flex', gap: 48, alignItems: 'center', padding: '8px 0' }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 13, whiteSpace: 'nowrap' }}>
                                    <input type="radio" value="percent" checked={limitType === 'percent'} onChange={() => setLimitType('percent')} />
                                    % of territory
                                </label>
                                <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 13, whiteSpace: 'nowrap' }}>
                                    <input type="radio" value="static" checked={limitType === 'static'} onChange={() => setLimitType('static')} />
                                    Static count
                                </label>
                            </div>
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>{limitType === 'static' ? 'MAX # OF TERRITORY TARGETS TO RECLASSIFY' : 'MAX % OF TERRITORY TARGETS TO RECLASSIFY'} <div className={styles.required}>*</div></div>
                            <div className={styles.inputSubtitle}>Use "0" for unlimited</div>
                            <input type="number" min={0 || undefined} className={valid ? styles.default : styles.error} value={maxChangesPerTerritory} onChange={(event) => {
                                setMaxChangesPerTerritory(event.target.value)
                            }} />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>{limitType === 'static' ? 'MAX # 🢁 PLANNED CALLS PER TERRITORY' : '% 🢁 PLANNED CALLS PER TERRITORY'} <div className={styles.required}>*</div></div>
                            <div className={styles.inputSubtitle}>Use "0" for unlimited</div>
                            <input type="number" min={0 || undefined} className={valid ? styles.default : styles.error} value={maxCallsPerTerritory} onChange={(event) => {
                                setMaxCallsPerTerritory(event.target.value)
                            }} />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>{limitType === 'static' ? 'MIN # OF TERRITORY TARGETS TO RECLASSIFY' : 'MIN % OF TERRITORY TARGETS TO RECLASSIFY'} <div className={styles.required}>*</div></div>
                            <div className={styles.inputSubtitle}>Use "0" for unlimited</div>
                            <input type="number" min={0 || undefined} className={valid ? styles.default : styles.error} value={minChangesPerTerritory} onChange={(event) => {
                                setMinChangesPerTerritory(event.target.value)
                            }} />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>{limitType === 'static' ? 'MIN # 🢃 PLANNED CALLS PER TERRITORY' : '% 🢃 PLANNED CALLS PER TERRITORY'} <div className={styles.required}>*</div></div>
                            <div className={styles.inputSubtitle}>Use "0" for unlimited</div>
                            <input type="number" min={0 || undefined} className={valid ? styles.default : styles.error} value={minCallsPerTerritory} onChange={(event) => {
                                setMinCallsPerTerritory(event.target.value)
                            }} />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>MAX {limitType === 'static' ? '#' : '%'} OF TERRITORY UPGRADES 🢁</div>
                            <div className={styles.inputSubtitle}>Use "0" for unlimited</div>
                            <input type="number" min={0 || undefined} className={styles.default} value={maxUpgradesPerTerritory} onChange={(event) => {
                                setMaxUpgradesPerTerritory(event.target.value)
                            }} />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>MAX {limitType === 'static' ? '#' : '%'} OF TERRITORY DOWNGRADES 🢃</div>
                            <div className={styles.inputSubtitle}>Use "0" for unlimited</div>
                            <input type="number" min={0 || undefined} className={styles.default} value={maxDowngradesPerTerritory} onChange={(event) => {
                                setMaxDowngradesPerTerritory(event.target.value)
                            }} />
                        </div>
                    </div>
                    <div className={styles.buttonRow}>
                        <div id={styles.cancel}
                            onClick={() => {
                                props.close()
                            }
                            }>CANCEL</div>
                        <div type="submit" id={styles.submit} className={wiggle ? styles.Wiggle : ""} onClick={() => {
                            if (name !== "" && props.team !== "" && startDate !== "" && endDate !== "") {
                                props.setExercise({
                                    ...props.exercise,
                                    name: name,
                                    team: props.team,
                                    exerciseType: props.exerciseType,
                                    startDate: startDate,
                                    endDate: endDate,
                                    maxChangesPerTerritory: maxChangesPerTerritory,
                                    minChangesPerTerritory: minChangesPerTerritory,
                                    maxCallsPerTerritory: maxCallsPerTerritory,
                                    minCallsPerTerritory: minCallsPerTerritory,
                                    maxUpgradesPerTerritory: maxUpgradesPerTerritory,
                                    maxDowngradesPerTerritory: maxDowngradesPerTerritory,
                                    limitType: limitType
                                })
                                props.setView(props.view + 1)
                            }
                            else {
                                setWiggle(true)
                                setValid(false)
                                setTimeout(() => {
                                    setWiggle(false)
                                }, 500);
                            }
                        }
                        }>NEXT</div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default AddExercise
